import { TireItem } from './TireItem';

export default TireItem;
